import { render, staticRenderFns } from "./commission-edit.pug?vue&type=template&id=0c3d03bf&lang=pug&"
import script from "./commission-edit.ts?vue&type=script&lang=ts&"
export * from "./commission-edit.ts?vue&type=script&lang=ts&"
import style0 from "./commission-edit.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports